import { isEqual } from 'lodash';

export type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};

export function moveArrayItem<T>(array: Array<T>, from: number, to: number): Array<T> {
  const _array = [...array];
  const items = _array.splice(from, 1);
  _array.splice(to, 0, ...items);
  return _array;
}

export function removeDuplicates<T>(lastValues: T[], currentValues: T[], replaceValue: T): T[] {
  const foundIndex = currentValues.findIndex((currentValue, index) => {
    const lastValue = lastValues[index];
    return !isEqual(lastValue, currentValue);
  });
  const duplicateValue = currentValues[foundIndex];
  return currentValues
    .map((currentValue, index) => {
      // replace w/ default if matching duplicate
      return isEqual(duplicateValue, currentValue) && index !== foundIndex ? replaceValue : currentValue;
    });
}
